
function fadeSite() {
    $(".mainPage").length ? fadeMainPage() : fadeDefaultPage();
}

function fadeDefaultPage() {
    animateFromTo("#header, .wrapper", timeShowHide * 2 / 1000, {}, { opacity: 1, ease: Power2.easeOut });
    if ($(".page404").length) fade404Page();
}

function fadeMainPage() {
    $("#header, .wrapper").fadeTo(0, 1);
    let transformY = 50;
    let time = 2;
    let ease = Power2.easeOut;
    let titleText = titleTextWrapScrolledBlock.find(".titleText").first();
    // titleText
    animateFromTo(titleText, time,
        { opacity: 0, y: -transformY * 2, z: -transformY },
        { opacity: 1, y: 0, z: 0, ease: ease });
    // header
    animateFromTo('#header, #mainPageTopBlock', time / 2,
        { opacity: 0, y: -transformY * 2 },
        { opacity: 1, y: 0, ease: ease }, time * 0.75);
};

function animateFromTo(elem, time, from, to, delay = 0) {
    TweenMax.fromTo(elem, time, from, to).delay(delay);
};